"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ValidationMessage = _interopRequireDefault(require("../ValidationMessage"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _HelpText = _interopRequireDefault(require("../HelpText"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _TextLink = _interopRequireDefault(require("../TextLink"));

var _Textarea = _interopRequireDefault(require("../Textarea"));

var styles = {
  "TextField": "TextField__TextField___Sf6eo",
  "TextField--small": "TextField__TextField--small___13h4C",
  "TextField--medium": "TextField__TextField--medium___1bB-F",
  "TextField--large": "TextField__TextField--large___3GaTm",
  "TextField--full": "TextField__TextField--full___11DBK",
  "TextField__label-wrapper": "TextField__TextField__label-wrapper___2-MJT",
  "TextField__label-link": "TextField__TextField__label-link___u94cw",
  "TextField__validation-message": "TextField__TextField__validation-message___1Idkl",
  "TextField__help-text": "TextField__TextField__help-text___p4rVf",
  "TextField__hints": "TextField__TextField__hints___3Di2P",
  "TextField__count": "TextField__TextField__count___jiTTs"
};
var defaultProps = {
  testId: 'cf-ui-text-field',
  textarea: false,
  required: false,
  countCharacters: false,
  width: 'full'
};

var TextField = function TextField(props) {
  var validationMessage = props.validationMessage,
      className = props.className,
      textInputProps = props.textInputProps,
      testId = props.testId,
      width = props.width,
      formLabelProps = props.formLabelProps,
      textLinkProps = props.textLinkProps,
      labelText = props.labelText,
      helpText = props.helpText,
      textarea = props.textarea,
      countCharacters = props.countCharacters,
      required = props.required,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      value = props.value,
      name = props.name,
      id = props.id,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["validationMessage", "className", "textInputProps", "testId", "width", "formLabelProps", "textLinkProps", "labelText", "helpText", "textarea", "countCharacters", "required", "onChange", "onBlur", "onFocus", "value", "name", "id"]);

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      valueState = _useState2[0],
      setValueState = _useState2[1]; // Store a copy of the value in state.
  // This is used by this component when the `countCharacters`
  // option is on


  var handleOnChange = (0, _react.useCallback)(function (e) {
    setValueState(e.target.value);
    if (onChange) onChange(e);
  }, [onChange]);
  var widthClass = "TextField--".concat(width);
  var classNames = (0, _classnames["default"])(styles['TextField'], styles[widthClass], className);
  var Element = textarea ? _Textarea["default"] : _TextInput["default"];
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classNames
  }, otherProps, {
    "data-test-id": testId
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles['TextField__label-wrapper']
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], (0, _extends2["default"])({}, formLabelProps, {
    htmlFor: id,
    required: required
  }), labelText), textLinkProps && /*#__PURE__*/_react["default"].createElement(_TextLink["default"], (0, _extends2["default"])({
    className: styles['TextField__label-link']
  }, textLinkProps), textLinkProps.text)), /*#__PURE__*/_react["default"].createElement(Element, {
    error: !!validationMessage,
    name: name,
    id: id,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: handleOnChange,
    value: value,
    required: required,
    width: 'full'
  }), validationMessage && /*#__PURE__*/_react["default"].createElement(_ValidationMessage["default"], {
    className: styles['TextField__validation-message']
  }, validationMessage), (helpText || countCharacters) && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles['TextField__hints']
  }, helpText && /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    className: styles['TextField__help-text']
  }, helpText), countCharacters && textInputProps && textInputProps.maxLength && /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    className: (0, _classnames["default"])(styles['TextField__help-text'], styles['TextField__count'])
  }, valueState ? valueState.length : 0, "/", textInputProps.maxLength)));
};

exports.TextField = TextField;
TextField.defaultProps = defaultProps;
var _default = TextField;
exports["default"] = _default;